import { showSuccess } from "../errorservices/errorservices";
import {
  beneficiarypoints,
  paymentEndPoints,
  dashboardEndPoints,
  globalCountryEndPoints,
  customerAppStatusEndPoints,
  payerServiceEndPoints,
  rtpServiceEndPoints,
  accountServiceAssetsEndPoints,
} from "../urlConfig/apiEndpoints";
import type { ApiResponse } from "./ApiResponse";
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import type {
  AddBeneficiaryConfirmationPayload,
  Beneficiary,
  BeneficiaryActivationStatusPayload,
  BeneficiaryBulkApprovePayload,
  BeneficiaryCountryCodeIdentifierPayload,
  BeneficiaryCountryCodeIdentifierResponse,
  BeneficiaryDetailsPayload,
  BeneficiaryEligibleRequest,
  BeneficiaryEligibleResponse,
  BeneficiaryListPayload,
  BeneficiaryListPendingPayload,
  BeneficiaryPayload,
  BeneficiarySingleApprovePayload,
  BeneficiaryStatusResponse,
  BeneficiaryTransactionDetailsPayload,
  BeneficiaryTransactionDetailsResponse,
  BeneficiaryValidate,
  BeneficiaryValidatePayload,
  GlobalCountry,
  GlobalCountryPayload,
  GxDeleteBeneficiaryPayload,
  GxDeleteBeneficiaryResponse,
  RtpGlobalCountryList,
  SearchSwiftDetailsPayload,
  ToggleFavouritePayload,
  ToggleFavouriteResponse,
  Transaction,
  UpdateBeneficiaryPayload,
} from "@/app/types/beneficiaries";
import type {
  ApprovalRequiredTransactions,
  ApprovalRequiredTransactionsPayload,
  BankCurrencyPayload,
  BulkApprovePayload,
  BulkApproveResponse,
  CheckCutOff,
  CheckCutOffPayload,
  CheckLimiPayload,
  CheckLimit,
  CountResponse,
  CreditAccount,
  CreditToPayload,
  DebitAccount,
  DebitAccountPayload,
  FxQuoteCreateResponse,
  FxQuotePayload,
  FxRate,
  FxRatePayload,
  GetBalance,
  GetBalancePayload,
  GxAllCbSchedulePayload,
  GxAllCbScheduleResponse,
  GxAllCbTransfersPayload,
  GxAllCbTransfersResponse,
  GxRtpCancelledPayload,
  GxRtpCancelledResponse,
  GxRtpDashboardRtpAgingResponse,
  GxRtpDashboardUnpaidSummaryPayload,
  GxRtpDashboardUnpaidSummaryResponse,
  GxRtpFilterPayload,
  GxRtpFilterResponse,
  GxRtpViewIndividualResponse,
  InitiateTransfer,
  InitiateTransferPayload,
  LfiPollingCheckPayload,
  LookupPayload,
  Lookups,
  OnlyRtpSubmitPayload,
  OnlyRtpSubmitResponse,
  PaymentByMonthPayload,
  PaymentByMonthResponse,
  PaymentCharges,
  PaymentChargesPayload,
  PaymentTransaction,
  PaymentType,
  PurposeOfCode,
  PurposeOfCodePayload,
  QuickTransferResponse,
  RecentTransactionsPayload,
  RecentTransactionsResponse,
  RtpAssetsCasaPayload,
  RtpAssetsCasaResponse,
  ReSubmitConsentPayload,
  RtpDashboardGetOverduePayload,
  RtpDashboardGetOverdueResponse,
  RtpDashboardRtpTrendsPayload,
  RtpDashboardRtpTrendsResponse,
  RtpDashboardTodayRequestPayload,
  RtpDashboardTodayRequestResponse,
  RtpDuplicatePayload,
  RtpDuplicateResponse,
  RtpGetDepositAccountsPayload,
  RtpGetDepositAccountsResponse,
  RtpGetUserListPayload,
  RtppayerviewPayload,
  RtppayerviewResponse,
  RtpSavePayerSubmitPayload,
  RtpSavePayerSubmitResponse,
  RtpSubmitPayload,
  RtpSubmitResponse,
  RtpUserList,
  RtpViewIndividualPayload,
  RtpViewSummaryPayload,
  RtpViewSummaryResponse,
  ScheduledDetailsPayload,
  ScheduledDetailsResponse,
  SchedulePaymentTransferPayload,
  SchedulePaymentTransferResponse,
  SendForRepairListPayload,
  SingleApprovePayload,
  SingleApproveResponse,
  TopBenificiariesGraphData,
  TopBenificiariesGraphResponse,
  ViewDetailsPayload,
  GetBeneficiaryListPayload,
  GetBeneficiaryList,
  ScheduleViewPayload,
  SheduledViewList,
  PaymentTypesForInitiate,
  CountryInfo,
  ConfirmBeneficiaryPayload,
  ConfirmBeneficiaryResponse,
  InitiateAaniTransferPayload,
  RecentBeneficiaryPayload,
  RecentBeneficiaryData,
  VerifyGOTPPayload,
  AaniInitiateSuccess,
  CentalBankAccountPayload,
  RecentPayerPayload,
  RecentPayerReponse,
  VerifyPayerPayload,
  VerifyPayerResponse,
  NotificationList,
  RequestDetailsApiPayload,
  RequestDetailsResponse,
  RTPRequestRejectPayload,
  ResendRTPRequestPayload,
} from "@/app/types/payments";
import type { GenericPayload } from "@/app/types/genericTypes";
import { getToken } from "@/app/services/context/tokenGetter";
import Swal from "sweetalert2";
import { PAYMENTS_ERROR_MESSAGES } from "@/app/utils/ErrorMessages";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  showCloseButton: true,
  background: "#fff",
  iconColor: "#000",
  customClass: {
    title: "toast-title",
  },
  didOpen: () => {
    const container = document.querySelector(".swal2-container") as HTMLElement;
    if (container) {
      container.style.zIndex = "9999999";
    }
  },
});

const showError = (errorCode: string) => {
  Toast.fire({
    icon: "error",
    title: PAYMENTS_ERROR_MESSAGES[errorCode] ?? "Unknown error",
    background: "#fff5f5",
    iconColor: "#d33",
  });
};

import { executeLogout } from "@/app/utils/loginFlow/logoutHelper";
import { store, type RootState } from "@/app/redux/store";
import {
  CORRELATION_ID_HEADER,
  generateCorrelationId,
} from "@/app/utils/loginFlow/correlationId";

const getTenantId = (): string | undefined => {
  const state = store.getState() as RootState;
  return state.userData?.data?.tenantId;
};

// ---------------- Auth logout registration ----------------
const handleUnauthorized = (err: any) => {
  executeLogout();
  return Promise.reject(err);
};

const handleApiRequest = async <T>(
  method: typeof axios.get | typeof axios.post | typeof axios.delete,
  url: string,
  payload: any = {},
  showSuccessMsg?: boolean,
): Promise<ApiResponse<T>> => {
  const token = getToken();
  const tenantId = getTenantId();
  const correlationId = generateCorrelationId();
  const headers: Record<string, string | undefined> = {
    Accept: "*/*",
    Authorization: `Bearer ${token}`,
    appId: tenantId,
    [CORRELATION_ID_HEADER]: correlationId,
  };
  if (!(payload instanceof FormData))
    headers["Content-Type"] = "application/json";

  const config: AxiosRequestConfig = { headers };
  const response: AxiosResponse =
    method === axios.get || method === axios.delete
      ? await method(url, { ...config, params: payload })
      : await method(url, payload, config);

  const data: ApiResponse<T> = response.data;
  if (response?.status === 200) {
    if (showSuccessMsg && data.errorMessage) showSuccess(data.errorMessage);
    return data;
  } else if (data?.status === 401) {
    handleUnauthorized;
    throw null;
  } else {
    // if (data?.errorCode && response?.status !== 202) {
    //   showError(data?.errorCode);
    // } else if (response?.status === 202) {
    //   if (
    //     data?.errorCode === "1046" ||
    //     data?.errorCode === "1638" ||
    //     data?.errorCode === "1100"
    //   ) {
    //     showError(data?.errorCode);
    //   }
    // }

    throw data;
  }
};

// ---------------- Exported API GET methods ----------------
export const addBeneficiaryApi = (payload: BeneficiaryPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.addBeneficiary,
    payload,
  );
};

export const addBeneficiaryConfirmationApi = (
  payload: AddBeneficiaryConfirmationPayload,
) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.addBeneficiaryConfirmation,
    payload,
  );
};

export const gxBeneficiaryListApi = (payload: BeneficiaryListPayload) => {
  return handleApiRequest<Beneficiary[]>(
    axios.post,
    beneficiarypoints.gxBeneficiaryList,
    payload,
  );
};

export const gxBeneficiaryPendingListApi = (
  payload: BeneficiaryListPendingPayload,
) => {
  return handleApiRequest(
    axios.post,
    beneficiarypoints.gxBeneficiaryPendingList,
    payload,
  );
};

export const gxSearchswiftApi = (payload: SearchSwiftDetailsPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.gxSearchswift,
    payload,
  );
};

// api layer
export const updateBeneficiaryApi = (payload: UpdateBeneficiaryPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.updateBeneficiary,
    payload,
  );
};

export const gxBeneficiaryDetailsApi = (payload: BeneficiaryDetailsPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.gxBeneficiaryDetails,
    payload,
  );
};

export const gxBeneficiaryTransactionsSummaryApi = (
  payload: GenericPayload,
) => {
  return handleApiRequest<Transaction[]>(
    axios.post,
    beneficiarypoints.gxBeneficiaryTransactionsSummary,
    payload,
  );
};

export const gxBeneficiaryTransactionDetailsApi = (
  payload: BeneficiaryTransactionDetailsPayload,
) => {
  return handleApiRequest<BeneficiaryTransactionDetailsResponse>(
    axios.post,
    beneficiarypoints.gxBeneficiaryTransactionDetails,
    payload,
  );
};

export const gxToggleBeneficiaryFavouriteApi = (
  payload: ToggleFavouritePayload,
) => {
  return handleApiRequest<ToggleFavouriteResponse>(
    axios.post,
    beneficiarypoints.gxToggleFavourite,
    payload,
  );
};

export const gxBeneficiaryValidateApi = (
  payload: BeneficiaryValidatePayload,
) => {
  return handleApiRequest<BeneficiaryValidate>(
    axios.post,
    beneficiarypoints.gxBeneficiaryValidate,
    payload,
  );
};

export const gxBeneficiaryViewSummaryApi = (payload: GenericPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.gxBeneficiaryViewSummary,
    payload,
  );
};

export const gxBeneficiarySingleApproveApi = (
  payload: BeneficiarySingleApprovePayload,
) => {
  return handleApiRequest(
    axios.post,
    beneficiarypoints.gxBeneficiaryApprove,
    payload,
    true,
  );
};

export const gxBeneficiaryBulkApproveApi = (
  payload: BeneficiaryBulkApprovePayload,
) => {
  return handleApiRequest(
    axios.post,
    beneficiarypoints.gxBeneficiaryBulkApprove,
    payload,
    true,
  );
};

export const gxBeneficiaryActivationStatusApi = (
  payload: BeneficiaryActivationStatusPayload,
) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.gxBeneficiaryActivationStatus,
    payload,
  );
};

export const gxBeneficiaryUpdateElgibleApi = (
  payload: BeneficiaryEligibleRequest,
) => {
  return handleApiRequest<BeneficiaryEligibleResponse>(
    axios.post,
    beneficiarypoints.gxBeneficiaryUpdateElgible,
    payload,
  );
};

export const gxPendingViewSummaryApi = (payload: GenericPayload) => {
  return handleApiRequest<Beneficiary>(
    axios.post,
    beneficiarypoints.gxPendingViewSummary,
    payload,
  );
};

export const gxBeneficiaryCountryCodeIdentifierApi = (
  payload: BeneficiaryCountryCodeIdentifierPayload,
) => {
  return handleApiRequest<BeneficiaryCountryCodeIdentifierResponse>(
    axios.post,
    beneficiarypoints.gxBeneficiaryCountryCodeIdentifier,
    payload,
  );
};

export const GxBeneficiaryCountryApi = (payload: GlobalCountryPayload) => {
  return handleApiRequest<GlobalCountry[]>(
    axios.post,
    beneficiarypoints.gxBeneficiaryCountry,
    payload,
  );
};
// ....................... Payment Transfer Controller start ...........................
export const gxPaymentTypesApi = (payload?: PaymentTypesForInitiate) => {
  return handleApiRequest<PaymentType[]>(
    axios.post,
    paymentEndPoints.gxPaymentTypes,
    payload,
  );
};

export const gxPaymentLimitsApi = (payload: CheckLimiPayload) => {
  return handleApiRequest<CheckLimit>(
    axios.post,
    paymentEndPoints.gxPaymentLimits,
    payload,
  );
};

export const gxPaymentCutOffApi = (payload: CheckCutOffPayload) => {
  return handleApiRequest<CheckCutOff>(
    axios.post,
    paymentEndPoints.gxPaymentCutOff,
    payload,
  );
};

export const gxPaymentRegisteredApi = (payload: CreditToPayload) => {
  return handleApiRequest<CreditAccount[]>(
    axios.post,
    paymentEndPoints.gxPaymentRegistered,
    payload,
  );
};

export const gxPaymentPurposeCodesApi = (payload: PurposeOfCodePayload) => {
  return handleApiRequest<PurposeOfCode[]>(
    axios.post,
    paymentEndPoints.gxPaymentPurposeCodes,
    payload,
  );
};

export const gxPaymentPendingViewApi = (payload: ViewDetailsPayload) => {
  return handleApiRequest<PaymentTransaction>(
    axios.post,
    paymentEndPoints.gxPaymentPendingView,
    payload,
  );
};

export const gxPaymentPendingViewSummaryApi = (
  payload: ApprovalRequiredTransactionsPayload,
) => {
  return handleApiRequest<ApprovalRequiredTransactions[]>(
    axios.post,
    paymentEndPoints.gxPaymentPendingViewSummary,
    payload,
  );
};

export const gxPaymentInitiateTransferApi = (
  payload: InitiateTransferPayload,
) => {
  return handleApiRequest<InitiateTransfer>(
    axios.post,
    paymentEndPoints.gxPaymentInitiate,
    payload,
  );
};

export const gxRepairTransaction = (payload: InitiateTransferPayload) => {
  return handleApiRequest<InitiateTransfer>(
    axios.post,
    paymentEndPoints.gxReSubmitConsent,
    payload,
  );
};

export const gxInitiateAaniTransferApi = (
  payload: InitiateAaniTransferPayload,
) => {
  return handleApiRequest<AaniInitiateSuccess>(
    axios.post,
    paymentEndPoints.gxPaymentInitiate,
    payload,
  );
};

export const gxPaymentGxLookupsApi = (payload: LookupPayload) => {
  return handleApiRequest<Lookups[]>(
    axios.post,
    paymentEndPoints.gxPaymentGxLookups,
    payload,
  );
};

export const gxPaymentFxRateCalculateApi = (payload: FxRatePayload) => {
  return handleApiRequest<FxRate>(
    axios.post,
    paymentEndPoints.gxPaymentFxRateCalculate,
    payload,
  );
};

export const gxPaymentDebitAccountsApi = (payload: DebitAccountPayload) => {
  return handleApiRequest<DebitAccount[]>(
    axios.post,
    paymentEndPoints.gxPaymentDebitAccounts,
    payload,
  );
};

export const gxPaymentDebitAccountsBalanceApi = (
  payload: GetBalancePayload,
) => {
  return handleApiRequest<GetBalance>(
    axios.post,
    paymentEndPoints.gxPaymentDebitAccountsBalance,
    payload,
  );
};

export const gxPaymentChargeCalculateApi = (payload: PaymentChargesPayload) => {
  return handleApiRequest<PaymentCharges>(
    axios.post,
    paymentEndPoints.gxPaymentChargeCalculate,
    payload,
  );
};

export const gxPaymentBulkApproveApi = (payload: BulkApprovePayload) => {
  return handleApiRequest<BulkApproveResponse>(
    axios.post,
    paymentEndPoints.gxPaymentBulkApprove,
    payload,
  );
}; // changed RR name

export const gxPaymentBankCurrenciesApi = (payload: BankCurrencyPayload) => {
  return handleApiRequest<string[]>(
    axios.post,
    paymentEndPoints.gxPaymentBankCurrencies,
    payload,
  );
};

export const gxPaymentApproveApi = (payload: SingleApprovePayload) => {
  return handleApiRequest<SingleApproveResponse>(
    axios.post,
    paymentEndPoints.gxPaymentApprove,
    payload,
  );
};

export const gxPaymentFxQuotesRetrieveApi = (payload: any) => {
  return handleApiRequest(
    axios.post,
    paymentEndPoints.gxPaymentFxQuotesRetrieve,
    payload,
  );
};

export const gxPaymentFxQuotesCreateApi = (payload: FxQuotePayload) => {
  return handleApiRequest<FxQuoteCreateResponse>(
    axios.post,
    paymentEndPoints.gxPaymentFxQuotesCreate,
    payload,
  );
};

export const gxPaymentFxQuotesAcceptApi = (payload: any) => {
  return handleApiRequest(
    axios.post,
    paymentEndPoints.gxPaymentFxQuotesAccept,
    payload,
  );
};

export const gxPaymentCancelTransactionApi = (payload: any) => {
  return handleApiRequest(
    axios.post,
    paymentEndPoints.gxPaymentCancelTransaction,
    payload,
  );
};

// ....................... Payment Transfer Controller end ............................................

// ....................... Dashboard Get & Post API List Controller start .............................
export const gxDashboardScheduledViewSummaryApi = (
  payload: SchedulePaymentTransferPayload,
) => {
  return handleApiRequest<SchedulePaymentTransferResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardScheduledViewSummary,
    payload,
  );
};

export const gxDashboardScheduledApi = (
  payload: SchedulePaymentTransferPayload,
) => {
  return handleApiRequest<SchedulePaymentTransferResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardScheduled,
    payload,
  );
};

export const gxDashboardImmediateAttentionApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    dashboardEndPoints.gxDashboardImmediateAttention,
    payload,
  );
};

export const gxDashboardHistoryRecentApi = (
  payload: RecentTransactionsPayload,
) => {
  return handleApiRequest<RecentTransactionsResponse[]>(
    axios.post,
    dashboardEndPoints.gxDashboardHistoryRecent,
    payload,
  );
};

export const gxDashboardTopBeneficiariesGraphApi = (
  payload: TopBenificiariesGraphData,
) => {
  return handleApiRequest<TopBenificiariesGraphResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardTopBeneficiariesGraph,
    payload,
  );
};

export const gxDashboardQuickTransferSummaryApi = () => {
  return handleApiRequest<QuickTransferResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardQuickTransferSummary,
  );
};

export const gxDashboardPaymentByMonthChartApi = (
  payload: PaymentByMonthPayload,
) => {
  return handleApiRequest<PaymentByMonthResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardPaymentByMonthChart,
    payload,
  );
};

// ---------------- Exported API Get methods ----------------
export const gxDashboardApprovalsPendingCountApi = () => {
  return handleApiRequest<CountResponse>(
    axios.post,
    dashboardEndPoints.gxDashboardApprovalsPendingCount,
  );
};

// ......................... sys-country-controller GlobalCountryApi controller start ....................................

export const gxGlobalCountryApi = (payload: GlobalCountryPayload) => {
  return handleApiRequest<GlobalCountry[]>(
    axios.post,
    globalCountryEndPoints.gxGlobalCountry,
    payload,
  );
};

export const gxAppStatusApi = (payload: { type: string }) => {
  return handleApiRequest<BeneficiaryStatusResponse[]>(
    axios.post,
    customerAppStatusEndPoints.gxAppStatus, // <-- use your real endpoint
    payload,
  );
};

// ......................... sys-country-controller GlobalCountryApi controller end ....................................

// ....................... Dashboard Get & Post API List Controller end .............................

// ---------------- Exported API Delete methods ----------------
export const GxdeleteBeneficiaryApi = (payload: GxDeleteBeneficiaryPayload) => {
  return handleApiRequest<GxDeleteBeneficiaryResponse>(
    axios.post,
    beneficiarypoints.deleteBeneficiary,
    payload,
  );
};

export const gxGetSheduledDetails = (payload: ScheduledDetailsPayload) => {
  return handleApiRequest<ScheduledDetailsResponse>(
    axios.post,
    paymentEndPoints.gxPaymentScheduleDetails,
    payload,
  );
};

export const gxPollingCheckPayment = (payload: LfiPollingCheckPayload) => {
  return handleApiRequest<any>(
    axios.post,
    paymentEndPoints.pollingCheck,
    payload,
  );
};

//----------------------------Payer flow Start API--------------------------

export const gxPayerGetViewSummaryApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerGetViewSummary,
    payload,
  );
};

export const gxPayerViewDetailsApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerViewDetails,
    payload,
  );
};
export const gxPayerAddNewPayerApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerAddNewPayer,
    payload,
  );
};

export const gxPayerViewTransactionApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerViewTransaction,
    payload,
  );
};

export const gxPayerEditPayerApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerEditPayer,
    payload,
  );
};

export const gxPayerDeletePayerApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerDeletePayer,
    payload,
  );
};

export const gxPayerViewPendingSummaryApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerViewPendingSummary,
    payload,
  );
};

export const gxPayerApprovalRejectApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerApprovalReject,
    payload,
  );
};

export const gxPayerBulkApprovalRejectApi = (payload: any) => {
  return handleApiRequest<any>(
    axios.post,
    payerServiceEndPoints.gxPayerBulkApprovalReject,
    payload,
  );
};

export const GxPayerCountryApi = (payload: GlobalCountryPayload) => {
  return handleApiRequest<GlobalCountry[]>(
    axios.post,
    payerServiceEndPoints.gxPayerCountryList,
    payload,
  );
};

//----------------------------Payer flow End API--------------------------

export const gxGlobalCountryListApi = (payload: GlobalCountryPayload) => {
  return handleApiRequest<RtpGlobalCountryList[]>(
    axios.post,
    globalCountryEndPoints.gxGlobalCountry,
    payload,
  );
};

export const gxRtpGetUserListApi = (payload: RtpGetUserListPayload) => {
  return handleApiRequest<RtpUserList>(
    axios.post,
    rtpServiceEndPoints.gxRtpGetUserList,
    payload,
  );
};

export const gxRtpGetDepositAccountsApi = (
  payload: RtpGetDepositAccountsPayload,
) => {
  return handleApiRequest<RtpGetDepositAccountsResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpGetDepositAccounts,
    payload,
  );
};

export const gxRtpSubmitApi = (payload: RtpSubmitPayload) => {
  return handleApiRequest<RtpSubmitResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpSubmit,
    payload,
  );
};

export const gxRtpSavePayerSubmitApi = (payload: RtpSavePayerSubmitPayload) => {
  return handleApiRequest<RtpSavePayerSubmitResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpSavePayerSubmit,
    payload,
  );
};

export const gxOnlyRtpSubmitApi = (payload: OnlyRtpSubmitPayload) => {
  return handleApiRequest<OnlyRtpSubmitResponse>(
    axios.post,
    rtpServiceEndPoints.gxOnlyRtpSubmit,
    payload,
  );
};

export const gxRtpFilterApi = (payload: GxRtpFilterPayload) => {
  return handleApiRequest<GxRtpFilterResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpFilter,
    payload,
  );
};

export const gxRtpViewIndividualApi = (payload: RtpViewIndividualPayload) => {
  return handleApiRequest<GxRtpViewIndividualResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpViewIndividual,
    payload,
  );
};

export const gxRtpViewSummaryApi = (payload: RtpViewSummaryPayload) => {
  return handleApiRequest<RtpViewSummaryResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpViewSummary,
    payload,
  );
};

export const gxRtpDashboardRtpTrendsApi = (
  payload: RtpDashboardRtpTrendsPayload,
) => {
  return handleApiRequest<RtpDashboardRtpTrendsResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDashboardRtpTrends,
    payload,
  );
};

export const gxRtpDashboardGetOverdueApi = (
  payload: RtpDashboardGetOverduePayload,
) => {
  return handleApiRequest<RtpDashboardGetOverdueResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDashboardGetOverdue,
    payload,
  );
};

export const gxRtpDashboardUnpaidSummaryApi = (
  payload: GxRtpDashboardUnpaidSummaryPayload,
) => {
  return handleApiRequest<GxRtpDashboardUnpaidSummaryResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDashboardUnpaidSummary,
    payload,
  );
};

export const gxRtpDashboardRtpAgingApi = () => {
  return handleApiRequest<GxRtpDashboardRtpAgingResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDashboardRtpAging,
  );
};

export const gxRtpDashboardTodayRequestApi = (
  payload: RtpDashboardTodayRequestPayload,
) => {
  return handleApiRequest<RtpDashboardTodayRequestResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDashboardTodayRequest,
    payload,
  );
};

export const gxRtpDuplicateApi = (payload: RtpDuplicatePayload) => {
  return handleApiRequest<RtpDuplicateResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpDuplicate,
    payload,
  );
};

export const gxRtpCancelledApi = (payload: GxRtpCancelledPayload) => {
  return handleApiRequest<GxRtpCancelledResponse>(
    axios.post,
    rtpServiceEndPoints.gxRtpCancelled,
    payload,
  );
};

export const RtpAssetsCasaApi = (payload: RtpAssetsCasaPayload) =>
  handleApiRequest<RtpAssetsCasaResponse>(
    axios.post,
    accountServiceAssetsEndPoints.gxAssetsCasa,
    payload,
  );

export const RtpPayerViewDetailsApi = (payload: RtppayerviewPayload) => {
  return handleApiRequest<RtppayerviewResponse>(
    axios.post,
    payerServiceEndPoints.gxPayerViewDetails,
    payload,
  );
};

// --------------------ATP API Services end------------------------------------------------------------------

export const gxAllCbTransfers = (payload: GxAllCbTransfersPayload) => {
  return handleApiRequest<GxAllCbTransfersResponse>(
    axios.post,
    paymentEndPoints.gxAllCbTransfers,
    payload,
  );
};

export const gxAllCbSchedule = (payload: GxAllCbSchedulePayload) => {
  return handleApiRequest<GxAllCbScheduleResponse[]>(
    axios.post,
    paymentEndPoints.gxAllCbSchedule,
    payload,
  );
};

// ------------------------------Send for Repair List APi--------------------------------------------------------

export const gxGetSendForRepairList = (payload: SendForRepairListPayload) => {
  return handleApiRequest<RecentTransactionsResponse[]>(
    axios.post,
    paymentEndPoints.gxSendForRepairList,
    payload,
    false,
  );
};

// ----------------------------Re-Submit connsent-----------------------------------------------------------------

export const gxReSubmitConsent = (payload: ReSubmitConsentPayload) => {
  return handleApiRequest<SingleApproveResponse>(
    axios.post,
    paymentEndPoints.gxReSubmitConsent,
    payload,
  );
};

// ----------------------------- Get Beneficiary List--------------------------------------------------------------

export const gxGetBeneficiaryList = (payload: GetBeneficiaryListPayload) => {
  return handleApiRequest<GetBeneficiaryList[]>(
    axios.post,
    paymentEndPoints.gxGetBeneficiaryList,
    payload,
  );
};

// -------------------------------Get Schedule view ----------------------------------------------------------------

export const gxGetScheduleViewList = (payload: ScheduleViewPayload) => {
  return handleApiRequest<SheduledViewList[]>(
    axios.post,
    paymentEndPoints.gxGetScheduleView,
    payload,
  );
};

// ----------------------------Get country list -------------------------------------------------------

export const gxGetCountryList = () => {
  return handleApiRequest<CountryInfo[]>(
    axios.post,
    paymentEndPoints.gxGetCountries,
  );
};

export const gxBeneficiaryDetailsForPaymentApi = (
  payload: BeneficiaryDetailsPayload,
) => {
  return handleApiRequest<CreditAccount>(
    axios.post,
    paymentEndPoints.gxPaymentBeneficiaryDetails,
    payload,
  );
};

export const gxConfirmBeneficaryApi = (payload: ConfirmBeneficiaryPayload) => {
  return handleApiRequest<ConfirmBeneficiaryResponse>(
    axios.post,
    paymentEndPoints.gxConfirmBeneficiary,
    payload,
  );
};

export const gxGenerateOtpApi = () => {
  return handleApiRequest(axios.post, paymentEndPoints.gxGenerateOtp);
};

export const gxRecentBeneficiaryApi = (payload: RecentBeneficiaryPayload) => {
  return handleApiRequest<RecentBeneficiaryData[]>(
    axios.post,
    paymentEndPoints.gxRecentBeneficiary,
    payload,
  );
};

export const gxVerifyGOTPApi = (payload: VerifyGOTPPayload) => {
  return handleApiRequest<{ success: boolean }>(
    axios.post,
    paymentEndPoints.gxVerifyGOTP,
    payload,
  );
};

export const gxNonceApi = () => {
  return handleApiRequest<{ nonceId: string }>(
    axios.post,
    paymentEndPoints.gxNonce,
  );
};

export const gxApprovalNonceApi = () => {
  return handleApiRequest<{ nonceId: string }>(
    axios.post,
    paymentEndPoints.gxApproveNonce,
  );
};

export const gxRtpNounceApi = () => {
  return handleApiRequest<{ nonceId: string }>(
    axios.post,
    rtpServiceEndPoints.gxRtpRtpNounce,
  );
};

export const gxGetCentalBankAccountApi = (
  payload: CentalBankAccountPayload,
) => {
  return handleApiRequest<{ nonceId: string }>(
    axios.post,
    paymentEndPoints.gxCentranBankAccount,
    payload,
  );
};

export const gxRecentPayersApi = (payload: RecentPayerPayload) => {
  return handleApiRequest<RecentPayerReponse[]>(
    axios.post,
    rtpServiceEndPoints.gxRtpRecentPayers,
    payload,
  );
};

export const gxVerifyPayerApi = (payload: VerifyPayerPayload) => {
  return handleApiRequest<VerifyPayerResponse>(
    axios.post,
    rtpServiceEndPoints.gxVerifyPayer,
    payload,
  );
};

export const gxNotifiedListApi = () => {
  return handleApiRequest<NotificationList[]>(
    axios.post,
    rtpServiceEndPoints.gxNotifiedRequest,
  );
};

export const gxRequestDetailsApi = (payload: RequestDetailsApiPayload) => {
  return handleApiRequest<RequestDetailsResponse>(
    axios.post,
    rtpServiceEndPoints.gxRequestDetails,
    payload,
  );
};

export const gxDownloadReceiptApi = (payload: RequestDetailsApiPayload) => {
  return handleApiRequest<string>(
    axios.post,
    rtpServiceEndPoints.gxDownloadReceipt,
    payload,
  );
};

export const gxRTPPaymentApprovalListApi = (
  payload: ApprovalRequiredTransactionsPayload,
) => {
  return handleApiRequest<ApprovalRequiredTransactions[]>(
    axios.post,
    paymentEndPoints.gxRTPPaymentApprovalList,
    payload,
  );
};

export const gxRejectRtpRequestApi = (payload: RTPRequestRejectPayload) => {
  return handleApiRequest(
    axios.post,
    rtpServiceEndPoints.gxRTPRequest,
    payload,
  );
};

export const gxResendRtpRequestApi = (payload: ResendRTPRequestPayload) => {
  return handleApiRequest<{ message: string; updtDt: string | null }>(
    axios.post,
    rtpServiceEndPoints.gxResendRTPRequest,
    payload,
  );
};
